// extracted by mini-css-extract-plugin
export var container = "_qs-0";
export var table = "_qs-2";
export var tableWrapper = "_qs-1";